module.exports = __webpack_public_path__ + "static/media/LibertadMono-Regular.bd03060e.woff2";